import React, { useState, useEffect } from "react";
import API from "../Context/api";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await API.post("/auth/forgot-password", { email }); // Adjusted path
      setMessage(response.data.message);
      setMessageType("success");
      setEmail(""); // Clear input on success
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "An error occurred. Please try again.";
      setMessage(errorMsg);
      setMessageType("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Clear message after 5 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    // <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
    //   <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-xl shadow-lg">
    //     <h1 className="text-center text-2xl sm:text-3xl font-bold text-gray-900">
    //       Forgot Password
    //     </h1>

    //     {message && (
    //       <div
    //         className={`text-center text-sm sm:text-base p-3 rounded-md ${
    //           messageType === "success"
    //             ? "bg-green-100 text-green-700"
    //             : "bg-red-100 text-red-700"
    //         }`}
    //       >
    //         {message}
    //       </div>
    //     )}

    //     <form onSubmit={handleForgotPassword} className="space-y-6">
    //       <div>
    //         <label
    //           htmlFor="email"
    //           className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
    //         >
    //           Email
    //         </label>
    //         <input
    //           type="email"
    //           id="email"
    //           value={email}
    //           onChange={(e) => setEmail(e.target.value)}
    //           className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm sm:text-base"
    //           placeholder="Enter your email"
    //           required
    //           disabled={isSubmitting}
    //         />
    //       </div>
    //       <button
    //         type="submit"
    //         disabled={isSubmitting}
    //         className={`w-full py-2 rounded-md text-white font-medium transition duration-200 text-sm sm:text-base ${
    //           isSubmitting
    //             ? "bg-indigo-300 cursor-not-allowed"
    //             : "bg-indigo-600 hover:bg-indigo-700"
    //         }`}
    //       >
    //         {isSubmitting ? "Sending..." : "Request Reset Link"}
    //       </button>
    //     </form>

    //     <p className="text-center text-sm sm:text-base text-gray-600">
    //       Remember your password?{" "}
    //       <a href="/login" className="text-indigo-600 hover:underline">
    //         Login here
    //       </a>
    //     </p>
    //   </div>
    // </div>
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="flex w-[60%] h-[75%] border border-gray-300 rounded-lg overflow-hidden shadow-lg">
        {/* Left Panel: Image with Overlay */}
        <div className="flex-1 relative">
          <img
            src="https://images.unsplash.com/photo-1593642532973-d31b6557fa68?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
            alt="Inventory system"
            className="object-cover w-full h-full"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://via.placeholder.com/800x600.png?text=Image+Unavailable";
            }}
          />
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center px-6 text-center">
            <div>
              <h2 className="text-white text-2xl font-bold leading-tight mb-2">
                Smart Inventory System
              </h2>
              <p className="text-white text-sm opacity-90">
                Track stock. Save time. Stay in control.
              </p>
            </div>
          </div>
        </div>

        {/* Right Panel: Forgot Password Form */}
        <div className="flex-1 flex items-center justify-center bg-white px-6 py-12">
          <div className="max-w-md w-full space-y-6">
            <h1 className="text-center text-2xl sm:text-3xl font-bold text-gray-900">
              Forgot Password
            </h1>

            {message && (
              <div
                className={`text-center text-sm sm:text-base p-3 rounded-md ${
                  messageType === "success"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {message}
              </div>
            )}

            <form onSubmit={handleForgotPassword} className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm sm:text-base"
                  placeholder="Enter your email"
                  required
                  disabled={isSubmitting}
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full py-2 rounded-md text-white font-medium transition duration-200 text-sm sm:text-base ${
                  isSubmitting
                    ? "bg-indigo-300 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700"
                }`}
              >
                {isSubmitting ? "Sending..." : "Request Reset Link"}
              </button>
            </form>

            <p className="text-center text-sm sm:text-base text-gray-600">
              Remember your password?{" "}
              <a href="/login" className="text-indigo-600 hover:underline">
                Login here
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
